import(/* webpackMode: "eager" */ "/vercel/path0/app/burn/page.tsx");
